import { render, staticRenderFns } from "./hazopDetail.vue?vue&type=template&id=1d6afae1"
import script from "./hazopDetail.vue?vue&type=script&lang=js"
export * from "./hazopDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6afae1')) {
      api.createRecord('1d6afae1', component.options)
    } else {
      api.reload('1d6afae1', component.options)
    }
    module.hot.accept("./hazopDetail.vue?vue&type=template&id=1d6afae1", function () {
      api.rerender('1d6afae1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/hazop/hazopDetail.vue"
export default component.exports